import { Transforms } from 'slate';

import { isBlockType } from '../../../helpers';
import { TransformNodeOption } from '../../../helpers/types';
import { ColorDefinition } from '../../highlight/types';
import { ELEMENT_ROUNDED } from '../defaults';

export const removeRoundBackgroundColor = (editor, options, editorOption: TransformNodeOption) => {
  Transforms.setNodes(
    editor,
    {
      colorKey: null,
    },
    { match: (node: any) => isBlockType(node, options[ELEMENT_ROUNDED].type), ...editorOption }
  );
};

export const setRoundBackgroundColor = (
  editor,
  options,
  color: ColorDefinition,
  editorOption: TransformNodeOption
) => {
  Transforms.setNodes(
    editor,
    {
      colorKey: color.key,
    },
    { match: (node: any) => isBlockType(node, options[ELEMENT_ROUNDED].type), ...editorOption }
  );
};
